jQuery(function($) { 
    var offset = 400;
    var duration = 200;
    $(window).on('scroll', function () {
        if ($(this).scrollTop() > offset) {
            $('.back-to-top').css('bottom', '60px');
        } else {
            $('.back-to-top').css('bottom', '-60px');
        }
    });

    $('.back-to-top').on('click', function (event) {
        event.preventDefault();
        $('html, body').animate({ scrollTop: 0 }, duration);
        return false;
    });
});